import { ChevronRight, ListOrdered, Plus, Trophy } from '../../components/ui/icons';

export function CreateMiniLeagueEntry({
  leagueName,
  onCreate,
  onJoin
}: {
  leagueName?: string;
  onCreate: () => void;
  onJoin: () => void;
}) {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/5 bg-card shadow-tile">
      <button
        type="button"
        onClick={onCreate}
        className="tap flex w-full items-center gap-[13px] p-4 text-left transition-transform active:scale-[0.99]"
      >
        <div className="grid h-[46px] w-[46px] place-items-center rounded-mark bg-gradient-to-br from-accent to-accent-deep text-white shadow-mark">
          <Trophy width={22} height={22} strokeWidth={2} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[15px] font-extrabold tracking-snug text-ink">Create a mini league</div>
          <div className="truncate text-[12px] font-medium text-ink2">
            {leagueName
              ? `Private ${leagueName} table with your mates`
              : 'Private table — your picks score it automatically'}
          </div>
        </div>
        <ChevronRight width={18} height={18} strokeWidth={2.2} className="text-ink3" />
      </button>
      <div className="flex border-t border-black/5">
        <button
          type="button"
          onClick={onJoin}
          className="tap flex flex-1 items-center justify-center gap-1.5 py-3 text-[13px] font-bold text-ink2"
        >
          <ListOrdered width={15} height={15} strokeWidth={2.2} />
          Join with code
        </button>
        <div className="w-px bg-black/5" />
        <button
          type="button"
          onClick={onCreate}
          className="tap flex flex-1 items-center justify-center gap-1.5 py-3 text-[13px] font-bold text-accent-ink"
        >
          <Plus width={15} height={15} strokeWidth={2.4} />
          Create new
        </button>
      </div>
    </div>
  );
}
